/** Registers every prologue data set with the shared registries (idempotent). */
import { SceneKeys } from '@/core/scenes/keys';
import { registerMemoryStages } from '@/cinematics';
import { registerPrologueDialogues } from './dialogue';
import { registerPrologueTimelines } from './cinematics';
import { registerPrologueMaps } from './maps';
import { registerPrologueActorDefs } from './actors';
import { STAGES } from './stages/defs';
import { PrologueStageScene } from './stages/PrologueStageScene';

let registered = false;

export function registerPrologueContent(): void {
  if (registered) return;
  registered = true;
  registerPrologueActorDefs();
  registerPrologueMaps();
  registerPrologueDialogues();
  registerPrologueTimelines();
  registerMemoryStages(Object.values(STAGES).map((def) => ({
    key: def.id,
    timeline: def.intro,
    sceneKey: SceneKeys.MEMORY_STAGE,
    sceneClass: PrologueStageScene,
    style: { bg: def.bg, tint: def.tint, tintAlpha: def.tintAlpha, label: def.title, ...(def.vignette ? { vignette: def.vignette } : {}) },
  })));
}
